import React, { useState } from "react";
import Page from "@components/layout/page";
import ReactGA_4 from "react-ga4";
import { useRouter } from "next/router";
import { Button, Col, Title } from "@components/ui";
import Link from "next/link";
import { ISLAND_ID, LOGIN_PATH, THEME_COLOR } from "@utils/constants";
import { fetcherNew1819 } from "@utils/fetcherNew1819";
import { setAccessToken } from "@redux/actions/authActions";
import { useDispatch } from "react-redux";
import GetTranslatedStrings from "@helpers/GetTranslatedStrings";
import { localStorageUtil } from "@utils/storage";

export default function Torgid404() {
    const router = useRouter();
    const [hostname, setHostname] = useState(null);
    const [kennitala, setKennitala] = useState("");
    const dispatch = useDispatch();
    React.useEffect(() => {
        ReactGA_4.send({ hitType: "pageview", page: router.asPath });
        setHostname(window.location.origin);
        if (LOGIN_PATH === "/innskraning") {
            router.push("/innskraning/starfsfolk");
        }
    }, [router]);
    const t = GetTranslatedStrings();
    return (
        <Page showsSearchBar>
            <div className="d-flex flex-column align-items-center">
                <div className="row w-100">
                    {LOGIN_PATH !== "/innskraning" ? (
                        <LoginDialog
                            logo="/img/1819logo-blue.svg"
                            title="1819"
                            alt="1819 merki"
                            description="Hér getur þú nýskráð þig og breytt skráningunni þinni á 1819.is"
                            link={LOGIN_PATH}
                        />
                    ) : (
                        <LoginDialog
                            logo="/img/1819logo-blue.svg"
                            title="Innskráning starfsmanna"
                            alt="1819 merki"
                            description="Hér getur þú skráð þig inn sem starfsmaður á 1819.is"
                            link="/innskraning/starfsfolk"
                        />
                    )}
                    {LOGIN_PATH !== "/innskraning" && (
                        <LoginDialog
                            logo="/img/sms-login.png"
                            title={t.sms_gateway}
                            description={"Hér finnur þú SMS gáttina okkar.\n\n"}
                            descriptionComponent={
                                <div>
                                    <p className="text-center torgid-text-secondary mb-0">
                                        Hér finnur þú SMS gáttina okkar.
                                    </p>
                                    <p className="text-center torgid-text-secondary">
                                        Vantar þig aðgang?{" "}
                                        <Link href="/um/thjonusta/sms-gatt/">
                                            <span
                                                style={{
                                                    color: THEME_COLOR,
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                Skráðu þig hér!
                                            </span>
                                        </Link>
                                    </p>
                                </div>
                            }
                            link={LOGIN_PATH}
                        />
                    )}
                </div>
                {hostname?.startsWith("http://localhost") && (
                    <form
                        className="mt-4"
                        onSubmit={(e) => {
                            e.preventDefault();
                            fetcherNew1819("login/development", "POST", { kennitala })
                                .then(async (data) => {
                                    const { access_token } = data;
                                    localStorageUtil.setItem("access_token", access_token);
                                    await new Promise((resolve) => setTimeout(resolve, 100));
                                    dispatch(setAccessToken(access_token));
                                    localStorage.setItem("access_token", access_token);
                                    router.push("/mitt/notandi");
                                })
                                .catch(() => {});
                        }}
                    >
                        <div className="d-flex align-items-center">
                            <input
                                placeholder="Kennitala"
                                id="token"
                                name="token"
                                value={kennitala}
                                onChange={(e) => {
                                    setKennitala(e.target.value);
                                }}
                                style={{
                                    border: "1px solid #00000022",
                                    borderRadius: 200,
                                    padding: "5px 10px",
                                    marginRight: 10,
                                    minWidth: "200px",
                                }}
                            />
                            <Button text="Innskrá" style={{ height: 36, margin: 0 }} />
                        </div>
                    </form>
                )}
            </div>
        </Page>
    );
}

function LoginDialog({ title, logo, description, descriptionComponent, link, alt }) {
    return (
        <Col md={6} className="mx-auto" style={{ flexGrow: 1 }}>
            <div
                style={{ borderRadius: 20 }}
                className="torgid-background-secondary p-2 mb-4 torgid-border"
            >
                <a href={link}>
                    <div className="text-center mb-3">
                        <img
                            className="mt-3"
                            src={logo}
                            alt={alt}
                            style={{ width: "auto", height: 100 }}
                        />
                    </div>
                    <Title className="text-center mt-3 mb-3">{title}</Title>
                </a>
                <div style={{ minHeight: "3em" }}>
                    {descriptionComponent ? (
                        descriptionComponent
                    ) : (
                        <p className="text-center torgid-text-secondary">{description}</p>
                    )}
                </div>
                <a href={link}>
                    <div className="text-center mb-3">
                        <button className="btn btn-primary mx-auto">Innskráning</button>
                    </div>
                </a>
            </div>
        </Col>
    );
}
